/** Column width limits and shared defaults for styled Excel export. */
export const AUTO_FIT = {
  MIN_WIDTH: 0,
  MAX_WIDTH: 200,
  PADDING: 2,
};

/** Placeholder shown in the table UI for empty cells; exported as blank. */
export const EMPTY_CELL_PLACEHOLDER = "--";

/** Default font size applied to exported cells. */
export const DEFAULT_FONT_SIZE = 12;

/** Name of the single worksheet written to the workbook. */
export const WORKSHEET_NAME = "Sheet 1";

/** Empty gutter row/column before table content (1-based: content starts at row/col 2). */
export const EXPORT_ROW_OFFSET = 0; // TODO: change to 1 when we confirm with client
export const EXPORT_COL_OFFSET = 0; // TODO: change to 1 when we confirm with client

/** Width of the empty left gutter column. */
export const GUTTER_COLUMN_WIDTH = 3;

/** Blank rows between the table and the page name footer. */
export const PAGE_FOOTER_GAP_ROWS = 1;

/** Table outline and section borders (thin ≈ 1px, black). */
export const SECTION_BORDER = {
  style: "thin",
  color: { argb: "FF000000" },
};
